import React from 'react';

// components
import Asset from './Asset';

export default function TextImage(props) {
    const { data } = props;
    return (
        <div className="grid grid--1-2 mb-80px md:mb-120px">
            <div>
                <Asset data={data.blockImage[0]?.imageFile} title={data.blockImage[0]?.title} />
            </div>
            <div className="flex wrap">
                <div className="rich-text" dangerouslySetInnerHTML={{ __html: data.blockCopy }} />
            </div>
        </div>
    );
}
